import { TableOfContentsListing } from "@common/utils/redline/ooxml/table-of-contents-listing";

import { withTemporaryTrackingMode, withWordContextWrite } from "./document";

const FIELD_UPDATE_REQUIREMENT = { set: "WordApi", version: "1.5" };

function writtenPackagesHoldListedParagraph(writtenPackageOoxmls: readonly string[], tableOfContentsFields: Word.Field[]): boolean {
    const styleNamesListedByName = TableOfContentsListing.styleNamesListedBy(tableOfContentsFields.map((field) => field.code));
    return writtenPackageOoxmls.some((writtenPackageOoxml) => TableOfContentsListing.packageHoldsListedParagraph(writtenPackageOoxml, styleNamesListedByName));
}

export async function updateTableOfContentsFields(writtenPackageOoxmls: readonly string[]): Promise<number> {
    if (writtenPackageOoxmls.length === 0) return 0;
    if (!Office.context.requirements.isSetSupported(FIELD_UPDATE_REQUIREMENT.set, FIELD_UPDATE_REQUIREMENT.version)) return 0;
    return withWordContextWrite(async (context) => {
        const tableOfContentsFields = context.document.body.fields.getByTypes([Word.FieldType.toc]);
        tableOfContentsFields.load("items");
        await context.sync();
        const tableOfContentsFieldItems = tableOfContentsFields.items;
        if (tableOfContentsFieldItems.length === 0) return 0;
        if (!writtenPackagesHoldListedParagraph(writtenPackageOoxmls, tableOfContentsFieldItems)) return 0;
        await withTemporaryTrackingMode(context, Word.ChangeTrackingMode.off, async () => {
            for (const field of tableOfContentsFieldItems) field.updateResult();
            await context.sync();
        });
        return tableOfContentsFieldItems.length;
    });
}
